export default function getLocalizedPath(path, language) {
    const [pathname, search = ''] = path.split('?')
    const searchParams = new URLSearchParams(search)

    if (language === 'zh') {
        searchParams.set('lang', 'zh')
    } else {
        searchParams.delete('lang')
    }

    const nextSearch = searchParams.toString()

    return `${pathname}${nextSearch ? `?${nextSearch}` : ''}`
}
